import {TweenMax} from "gsap";
import {TimelineMax} from "gsap";
import ScrollMagic from "scrollmagic";
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';
const controller = new ScrollMagic.Controller;
import Modaal from "modaal";
/**
 * informed
 * @constructor
 */
class Product {
  constructor() {
    this.init();
  }
  /**
   * サンプル
   */
  init() {
    this.alphaPremium1();
    this.alphaPremium2();  
    $(".video-cm").modaal({type:'video'});
  }
  
  alphaPremium1(){
    new ScrollMagic.Scene({
      triggerElement: ".js-trigger",
      triggerHook: 0.9,
      offset: 50,
      reverse: false
    })
    .setClassToggle(".js-fade-in", "fade-in") // add class to reveal
    // .addIndicators() // add indicators (requires plugin)
    .addTo(controller)
  }
  alphaPremium2(){
    new ScrollMagic.Scene({
      triggerElement: ".js-trigger",
      triggerHook: 0.4,
      offset: 50,
      reverse: false
    })
    .setClassToggle(".js-fixed", "fixed") // add class to reveal
    // .addIndicators() // add indicators (requires plugin)
    .addTo(controller)
  }
};

export default Product;
